import * as React from 'react';
import DynamicIcon from './dynamicicon';
import JisButton from './controls/jisButton';

export default function JisDialogForm({children,title="",onClose, minWidth='50%'}) {

  return (
   <div className='upload'><div className={ "dialog open" } >
                            <div className="container"  style={{width:'fit-content', minWidth:minWidth, maxWidth:'90%'}}>
                                <div className="heading">
                                    
                                    <div className='header-title'>{title}</div>
<div className='iconcircle' onClick={() =>onClose()}>
    <DynamicIcon iname="x" size={18} />
</div>
                                        
                                </div>
                                <div className="body" >
                               {children}
                                </div>
                            </div>
                        </div></div>

  );
}
